import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Pengembalian Paket", -1)
const _hoisted_3 = { class: " col-span-2 " }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: " text-xs mb-1 color-blue-grey" }, "Resi", -1)
const _hoisted_5 = { class: " font-medium break-words" }
const _hoisted_6 = { class: " col-span-2 " }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: " text-xs mb-1 color-blue-grey" }, "Kurir Paket", -1)
const _hoisted_8 = {
  key: 0,
  class: "flex gap-2 items-center"
}
const _hoisted_9 = { class: "font-semibold cursor-pointer break-words" }
const _hoisted_10 = { class: " col-span-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: " text-xs mb-1 color-blue-grey" }, "Alasan Pengembalian", -1)
const _hoisted_12 = { class: " col-span-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: " text-xs mb-1 color-blue-grey" }, "Bukti Foto", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-black text-left"
}
const _hoisted_15 = {
  key: 1,
  class: "inline-flex gap-2 mx-auto items-center"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "pi pi-upload color-blue-grey" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, "Upload Foto", -1)
const _hoisted_18 = { class: "flex gap-4 justify-start" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Paket Dikembalikan")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowModal,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModal = $event)),
    dismissableMask: true,
    modal: true,
    style: { width: '80vw' },
    onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideDialog())),
    class: "dialog-confirm"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_Button, {
          class: "btn-red font-semibold px-10 text-white",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitPackageReturn()))
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black font-semibold px-10 py-1",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideDialog()))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("section", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listPackage, (list, index) => {
          return (_openBlock(), _createBlock("div", {
            class: " grid grid-cols-10 gap-4 mb-2",
            key: list.Id
          }, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", null, [
                _hoisted_4,
                _createVNode("p", _hoisted_5, _toDisplayString(list.DeliveryWaybill), 1)
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", null, [
                _hoisted_7,
                (list.CourierProfile)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      (list?.CourierProfile?.Picture)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: `${_ctx.API_BASE}${list?.CourierProfile?.Picture}`,
                            class: "rounded-full object-cover w-8 h-8"
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_Avatar, {
                            key: 1,
                            label: list?.CourierProfile?.Name.charAt(0),
                            shape: "circle"
                          }, null, 8, ["label"])),
                      _createVNode("p", _hoisted_9, _toDisplayString(list?.CourierProfile?.Name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", null, [
                _hoisted_11,
                _createVNode(_component_InputText, {
                  placeholder: "Tulis Alasan (Wajib)",
                  ref: "inputCekResi",
                  class: "input-grey w-full rounded-lg",
                  modelValue: list.Reason,
                  "onUpdate:modelValue": ($event: any) => (list.Reason = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", null, [
                _hoisted_13,
                _createVNode(_component_file_upload, {
                  class: "container-file-upload rounded-lg cursor-pointer",
                  "input-id": `upload-file-${index}`,
                  modelValue: list.File,
                  "onUpdate:modelValue": ($event: any) => (list.File = $event),
                  accept: "image/*"
                }, {
                  default: _withCtx(() => [
                    (list.File.length > 0)
                      ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(list.File[0].name), 1))
                      : (_openBlock(), _createBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _hoisted_17
                        ]))
                  ]),
                  _: 2
                }, 1032, ["input-id", "modelValue", "onUpdate:modelValue"])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}